<div
  [class.spot-price-requests-link]="currentStep === 10"
  [class.spot-table-row-arrow]="currentStep === 11"
>
  <div class="spot-overlay"></div>
  <markant-platform-backoffice-organization-bookings-table
    slot="highlight-dialog-static-view-content"
    [class.demo-screen]="DEMO_SCREEN_STEPS | arrayIncludes: currentStep"
    [demoContent]="[demoBookings, activeFilters]"
  ></markant-platform-backoffice-organization-bookings-table>
</div>
